module.exports = __webpack_public_path__ + "public/img/tuangou.e647f3e4.png";